import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { setVenueVideoActive } from '../actions/venues-card-video';

export const useVenueCardAnimationPlayPause = () => {
  const dispatch = useDispatch();
  const pathname = useLocation().pathname;

  useEffect(() => {
    return () => {
      dispatch(setVenueVideoActive(''));
    };
  }, [pathname, dispatch]);
};
